import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { readEndpoint } from 'redux-json-api';
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import { selectRailways } from "../../modules/selectors/railway";
import TableBody from "@material-ui/core/TableBody";

import RailwayRow from "./RailwayRow";

class RailwayList extends Component {
  static propTypes = {
    // state props
    railways: PropTypes.arrayOf(PropTypes.shape({
      'id': PropTypes.string.isRequired,
      attributes: {
        'name': PropTypes.string.isRequired,
      }
    }))
  }

  render() {
    const { railways } = this.props;

    return (
      <Fragment>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Naam</TableCell>
              <TableCell>Phone number</TableCell>
              <TableCell/>
            </TableRow>
          </TableHead>

          <TableBody>
            {railways.map(railway => <RailwayRow key={`railway-${railway.id}`} railway={railway}/>)}
          </TableBody>

        </Table>
      </Fragment>
    );
  }
}
const mapStateToProps = (state) => ({
  railways: selectRailways(state),
});

const mapDispatchToProps = { readEndpoint };

export default connect(mapStateToProps, mapDispatchToProps)(RailwayList);
